// client/src/ui/theme/EducaTheme.js
//
// M06 Fase 4 - Tokens de tema Educa360 para Ant Design 5.
// Mapea los colores SCSS consolidados (client/src/scss/_color.scss) a la
// API de tema de AntD para que todos los componentes respeten la identidad
// visual de Educa360 sin overrides puntuales.

export const educaTheme = {
  token: {
    colorPrimary: "#2b323f", // $azul-button
    colorInfo: "#1d4aed", // $grad-start
    colorSuccess: "#245e55", // $tea
    colorWarning: "#ed773c", // $tangerine
    colorError: "#c63f3e", // $red-passion
    colorTextBase: "#1d1d1b", // $muted-blck
    borderRadius: 12,
    borderRadiusLG: 16,
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
  components: {
    Button: { borderRadius: 12, controlHeight: 36 },
    Card: { borderRadiusLG: 16 },
    Statistic: { contentFontSize: 28 },
  },
};
